import { AnimatePresence, motion } from "motion/react";
import { useVideoSettings } from "../../contexts/videoSettings/videoSettings.hook";
import { useMenu } from "../../contexts/menu/menu.hook";
import { MenuContentOptions } from "../../contexts/menu/Menu.types";
import { usePhone } from "../../contexts/phone/phone.hook";
import { usePrefersReducedMotion } from "../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import styles from "./Header.module.scss";
import { useEffect } from "react";

export const Header = ({ buyTicketsLink }: { buyTicketsLink: string }) => {
  const { isPlayingIntroVideo } = useVideoSettings();
  const { isMenuOpen, setIsMenuOpen, menuContent, setMenuContent, menuBg } =
    useMenu();
  const { setIsPhoneOpen } = usePhone();
  const { prefersReducedMotion } = usePrefersReducedMotion();

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const headerVariants = {
    hidden: prefersReducedMotion
      ? { opacity: 1, y: 0 }
      : { opacity: 0, y: "-150%" },
    visible: { opacity: 1, y: 0 },
  };

  const handleTrailerClick = () => {
    setMenuContent(MenuContentOptions.TRAILER);
  };

  useEffect(() => {
    if (menuContent === MenuContentOptions.TRAILER && menuBg === "black") {
      setIsMenuOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuContent, menuBg]);

  return (
    <AnimatePresence mode="popLayout">
      {!isPlayingIntroVideo && (
        <motion.header
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={{ duration: 1 }}
          variants={headerVariants}
          className={styles.headerWrapper}
        >
          <nav className={styles.nav}>
            <button
              onClick={() => {
                setIsPhoneOpen(false);
                setIsMenuOpen(false);
              }}
              className={styles.logo}
            >
              <img src="/SH_LOGO_SMALL_RED.png" alt="Skillhouse" />
            </button>
            <div className={styles.navLinks}>
              <button
                className={`${styles.menuBtn}${` ${styles.trailerBtn}`}`}
                onClick={handleTrailerClick}
              >
                Play Trailer
              </button>
              <a
                href={buyTicketsLink}
                target="_blank"
                className={styles.menuBtn}
                rel="noreferrer"
              >
                Get Tickets
              </a>
              <button onClick={handleMenuClick} className={styles.menuBtn}>
                {isMenuOpen ? "Close" : "Menu"}
              </button>
              <img
                src="/GEN_TV_LOGO.png"
                alt="GenTV"
                className={styles.genTVLogo}
              />
            </div>
          </nav>
        </motion.header>
      )}
    </AnimatePresence>
  );
};
